import React from 'react';
import Typography from '@material-ui/core/Typography';

const PromoPriceField = ({ record }) => {
  const promoPrice = record && record.promo_price;
  return <Typography>{promoPrice || 'None'}</Typography>;
};

export default PromoPriceField;
